module.exports = __webpack_public_path__ + "img/case-banner__list2.png?2976823d432b3aa6e7a9e36130a869de";